export function handleInputDecimals(value: string, decimals = 2) {
	const multiple = Math.pow(10, decimals);

	let newValue: number | string = value;

	if (isNaN(Number(value))) {
		newValue = parseInt(value.replace(/\D/g, ''));
	}

	newValue = formatDecimals(Number(newValue) / multiple, decimals);

	return newValue;
}

export function formatDecimals(value: number | string, decimals = 2) {
	let amount = value;

	if (typeof value === 'string') {
		amount = parseFloat(value.replace(',', '.'));

		if (isNaN(amount)) {
			amount = 0;
		}
	} else if (value === undefined) {
		amount = 0;
	}

	return amount.toLocaleString('pt-BR', {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
	});
}
